import axios from 'axios';
import { REVIEW_URI } from '../api/apiVersionConstants';

export default {
    async getEntityReviews() {
        return axios.get(`${REVIEW_URI}`);
    }
};
